import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable()
export class CitiesService {
    url: string = environment.url + `/resources/cities`;

    constructor(
        private http: HttpClient,
    ) {}

    // getCitiesByStateInitials fetches all cities related to a state with given initials. If no state_initials are provided, 
    // all available cities will be returned instead.
    getCitiesByStateInitials(state_initials: string): Observable<any> {
        if (state_initials == "") {
            return this.http.get(this.url);
        }

        return this.http.get(this.url, {
            params: new HttpParams().set('state_initials', state_initials)
        });
    }
}
